module.exports = __webpack_public_path__ + "static/media/milwaukee-county-logo.77676f11.png";